import { LinearProgress as MuiLinearProgress } from '@mui/material';

const getChildrenWidth = (children: React.ReactNode): string => {
  if (typeof children === 'string') {
    return `${children.length * 7}px`;
  }
  return '100%';
};

type LinearProgressProps = {
  children: React.ReactNode;
  backgroundColor?: string;
  barColor?: string;
};

export function LinearProgress({
  children,
  backgroundColor = 'var(--nn-color-foreground)',
  barColor = 'var(--nn-color-primary)',
}: LinearProgressProps) {
  return (
    <div
      style={{
        width: '100%',
        padding: '0.5rem 0',
        minWidth: getChildrenWidth(children),
      }}
    >
      <MuiLinearProgress
        sx={{
          backgroundColor: backgroundColor, // * Track.
          '& .MuiLinearProgress-bar': {
            backgroundColor: barColor, // * Actual bar.
          },
        }}
      />
    </div>
  );
}
